import React from 'react';
import Notification from './Notification';

const variantlist = [
    'success',
    'danger',
    'warning',
    'info',
]


function renderNotificationList(values) {
    const notifications = values.notification.notifications
    return notifications.map((item, i) => {
        const variant = variantlist[i % variantlist.length];
        const unsentUser = item.hotel.contacts.filter(user => !user.is_sent);
        const userName = unsentUser.length > 0 ? unsentUser[unsentUser.length-1].first_name + " " + unsentUser[unsentUser.length-1].last_name : ' ';
        const email = unsentUser.length >0?unsentUser[unsentUser.length-1].email:''
        return <Notification
            key={i}
            item={item}
            variant={variant}
            hotel_name={item.hotel.name}
            tour_name={item.tour.name}
            user_name={userName}
            email={email}
            onReadNotification={values.readNotificationList}
            onRemoveNotification={values.removeNotification}
        />
    });
}


class NotificationList extends React.Component {

    render() {
        const listItems = renderNotificationList(this.props)
        return (
            <div>{listItems}</div>
        )
    }
}

export default NotificationList;


// WEBPACK FOOTER //
// src/routes/notification/components/NotificationList.js